import { Button, ButtonProps } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { MouseEvent, ReactNode } from "react";
import Text from "../Text";
import { DEFAULT_FONTSIZE } from "../../utils/utils";

type StyledButtonProps = {
  onChange?: (e: MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  label?: ReactNode;
  shouldAddIcon?: boolean;
  shouldEditIcon?: boolean;
  eIcon?: ReactNode;
  sIcon?: ReactNode;
  fontSize?: string;
  fontWeight?: string | number;
} & ButtonProps;

/**
 * @summary this component design to maintain loose coupling and default button style
 *
 * @param onChange,
 *
 * @author rajkumar rathod
 */
const StyledButton = ({
  onChange,
  shouldAddIcon,
  shouldEditIcon,
  sIcon,
  eIcon,
  label,
  fontSize,
  fontWeight = "medium",
  ...others
}: StyledButtonProps) => {
  return (
    <Button
      variant={others?.variant ?? "contained"}
      size={others?.size ?? "large"}
      startIcon={
        sIcon ||
        (shouldAddIcon && <AddIcon />) ||
        (shouldEditIcon && <ModeEditOutlineOutlinedIcon />) ||
        others?.startIcon
      }
      endIcon={eIcon}
      {...others}
      sx={{ width: "fit-content", ...others.sx }}
    >
      <Text
        fontSize={fontSize ?? DEFAULT_FONTSIZE.fontSize}
        // c={"white"}
        fontWeight={fontWeight}
        noWrap
      >
        {label}
      </Text>
    </Button>
  );
};

export default StyledButton;
